
import React, { useEffect } from 'react';
import defaultClasses from './passwordReset.module.css';
import loginClasses from '../Login/login.module.css';
import { useStyle } from '../../utils/classify';

import { Form, message } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { EyeOutlined } from '@ant-design/icons';

import { usePasswordReset } from './usePasswordReset';
import TextInput from '../../components/formDesign/TextInput/textInput';
import LandingWelcome from '../../components/LandingWelcome/landingWelcome';
import ButtonNode from '../../components/formDesign/ButtonNode/buttonNode';
import {
    IconPasswordLockGreySvg,
    IconPasswordHideGreySvg,
    IconPasswordVisibleGreySvg
} from '../../components/IconsSvg/iconsSvg';

const PasswordReset = props => {

    const { formatMessage } = useIntl();
    const [messageApi, contextHolder] = message.useMessage();

    const talons = usePasswordReset();

    const {
        form,
        clientReady,
        loginLoading,
        onStartLogin,
        errorMsg,
        showErrorMsg,
        setShowErrorMsg,
        handleNavigateBack
    } = talons;

    useEffect(() => {
        if (showErrorMsg) {
            messageApi.open({
                type: 'error',
                content: errorMsg,
            });
            setShowErrorMsg(false);
        }

    }, [showErrorMsg, errorMsg, messageApi, setShowErrorMsg]);

    const classes = useStyle(loginClasses, defaultClasses, props.classes);

    return (
        <div className={classes.root}>
            {contextHolder}
            <aside className={classes.panel}>
                <div className={classes.panel_left}>
                    <LandingWelcome />
                </div>
                <div className={classes.panel_right}>
                    <div className={classes.right_box}>
                        <div className={classes.right_content}>
                            <h1>
                                <FormattedMessage id="passwordReset.passwordReset" defaultMessage={"Password Reset"} />
                            </h1>
                            <div className={classes.right_top_create}>
                                <FormattedMessage id="passwordReset.panelRightSpan" defaultMessage={"Don’t have an account?"} />
                            </div>
                            <Form className={classes.form} form={form} name="login_form" onFinish={onStartLogin} layout='vertical'>
                                <TextInput
                                    name="email"
                                    rules={[{
                                        required: true,
                                        message: formatMessage({
                                            id: "form.isRequired",
                                            defaultMessage: "{name} is required!"
                                        }, {
                                            name: formatMessage({
                                                id: "form.email",
                                                defaultMessage: "email"
                                            })
                                        })
                                    }]}

                                    label={formatMessage({
                                        id: "form.email",
                                        defaultMessage: "Email"
                                    })}
                                    placeholder={formatMessage({
                                        id: "form.placeholder",
                                        defaultMessage: "Please enter {name} "
                                    }, {
                                        name: formatMessage({
                                            id: "form.emailPlaceholder",
                                            defaultMessage: "email"
                                        })
                                    })}
                                />

                                <TextInput
                                    name="verifyToken"
                                    rules={[{
                                        required: true,
                                        message: formatMessage({
                                            id: "form.isRequired",
                                            defaultMessage: "{name} is required!"
                                        }, {
                                            name: formatMessage({
                                                id: "form.verificationCode",
                                                defaultMessage: "Verification code"
                                            })
                                        })
                                    }]}

                                    label={formatMessage({
                                        id: "form.verificationCode",
                                        defaultMessage: "Verification Code"
                                    })}
                                    placeholder={formatMessage({
                                        id: "form.placeholder",
                                        defaultMessage: "Please enter {name} "
                                    }, {
                                        name: formatMessage({
                                            id: "form.verificationCodePlaceholder",
                                            defaultMessage: "verification code"
                                        })
                                    })}
                                />

                                <TextInput
                                    name="password"
                                    rules={[{
                                        required: true,
                                        message: formatMessage({
                                            id: "form.isRequired",
                                            defaultMessage: "{name} is required!"
                                        }, {
                                            name: formatMessage({
                                                id: "form.password",
                                                defaultMessage: "Password"
                                            })
                                        })
                                    }]}
                                    inputType="password"
                                    label={formatMessage({
                                        id: "form.password",
                                        defaultMessage: "Password"
                                    })}
                                    placeholder={formatMessage({
                                        id: "form.placeholder",
                                        defaultMessage: "Please enter {name} "
                                    }, {
                                        name: formatMessage({
                                            id: "form.passwordPlaceholder",
                                            defaultMessage: "password"
                                        })
                                    })}
                                    prefix={<IconPasswordLockGreySvg />}

                                    iconRender={(visible) => (visible ? IconPasswordVisibleGreySvg
                                        : IconPasswordHideGreySvg)}
                                />
                                <TextInput
                                    name="passwordConfirm"
                                    rules={[{
                                        required: true,
                                        message: formatMessage({
                                            id: "form.isRequired",
                                            defaultMessage: "{name} is required!"
                                        }, {
                                            name: formatMessage({
                                                id: "form.confirmPassword",
                                                defaultMessage: "Confirm password"
                                            })
                                        })
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error(formatMessage({
                                                id: "passwordReset.passwordNotMatch",
                                                defaultMessage: "The new password that you entered do not match!"
                                            })));
                                        },
                                    })
                                    ]}
                                    inputType="password"
                                    label={formatMessage({
                                        id: "form.confirmPassword",
                                        defaultMessage: "Confirm password"
                                    })}
                                    placeholder={formatMessage({
                                        id: "form.placeholder",
                                        defaultMessage: "Please enter {name} "
                                    }, {
                                        name: formatMessage({
                                            id: "form.confirmPasswordPlaceholder",
                                            defaultMessage: "confirm password"
                                        })
                                    })}
                                    prefix={<IconPasswordLockGreySvg />}
                                    iconRender={(visible) => (visible ? IconPasswordVisibleGreySvg
                                        : IconPasswordHideGreySvg)}
                                />

                                <Form.Item shouldUpdate>
                                    {() => (
                                        <ButtonNode
                                            type="primary"
                                            htmlType="submit"
                                            disabled={
                                                !clientReady ||
                                                !!form.getFieldsError().filter(({ errors }) => errors.length).length
                                            }
                                            loading={loginLoading}
                                            style={{ width: '100%' }}
                                        >
                                            <FormattedMessage id="passwordReset.passwordReset" defaultMessage={"Password Reset"} />
                                        </ButtonNode>
                                    )}
                                </Form.Item>
                                <div className={classes.form_other}>
                                    <ButtonNode
                                        type="link"
                                    >
                                        <FormattedMessage id="passwordReset.rememberedPassword" defaultMessage={"Remembered your Password?"} />
                                    </ButtonNode>
                                </div>

                                <div className={classes.form_other}>
                                    <ButtonNode
                                        type="default"
                                        onClick={handleNavigateBack}
                                    >
                                        <FormattedMessage id="passwordReset.navigateBack" defaultMessage={"Back to Sign In"} />
                                    </ButtonNode>
                                </div>
                            </Form>
                        </div>
                        {/* <div className={classes.right_bottom}>
                            <FormattedMessage id="global.copyright " defaultMessage={"Copyright @ 2024 BCNetcom. All Rights Reserved"} />
                        </div> */}
                    </div>
                </div>
            </aside>
        </div>
    )
}

export default PasswordReset;